export class WindowUtils {

  public static scrollIntoView(elementId: string) {
    window.document.getElementById(elementId).scrollIntoView();
  }

}
